import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "Unassigned_Visits",
  class: "dashboard-card d-flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Active Patients")
], -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "mt-3 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Loading your active patients count", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "mt-5 text-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" There was a problem while fetching your active patients. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please try again. ")
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 2,
  class: "no-data"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "mb-3" }, " Good Job! There were no active patients. ", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "h-100 overflow-auto w-100 d-flex align-items-center p-2 active-patients" }
const _hoisted_14 = { class: "legend ms-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "ps-3" }, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "ps-2" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_CardTemplate = _resolveComponent("CardTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardTemplate, null, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        (_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ERROR "),
        (_ctx.hasError && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getActivePatientsCount()))
              }, "Try Again")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" NO DATA "),
        (_ctx.activePatientData.length === 0 && !_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, _hoisted_12))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" DATA "),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Chart, {
            type: "pie",
            data: _ctx.chartData,
            options: _ctx.chartOptions
          }, null, 8 /* PROPS */, ["data", "options"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("table", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePatientData, (activePatient) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: activePatient.id,
                  class: _normalizeClass(
                                    _ctx.ApplicationNamesEnum.getDescriptionUsingValue(activePatient.application) ==
                                    _ctx.active.label
                                        ? _ctx.getProductColorClass(_ctx.active.label)
                                        : 'text-black'
                                )
                }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.ApplicationNamesEnum.getDescriptionUsingValue(activePatient.application)), 1 /* TEXT */),
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("td", null, _toDisplayString(activePatient.count), 1 /* TEXT */)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}